//exporting object
export default {
  page: "Home"
};
